export const openPdfInNewWindow = (response) => {
    const file = new Blob([response], { type: 'application/pdf' });
    const fileURL = URL.createObjectURL(file);
    try {
        const newWindow = window.open(fileURL);
        if (newWindow) {
            newWindow.addEventListener('beforeunload', () => {
                URL.revokeObjectURL(fileURL);
            });
        }
    }
    catch (error) {
        URL.revokeObjectURL(fileURL);
        throw error;
    }
};
